const groupInAppRequest = 'In-App Request';
const groupInvestmentSupport = 'Investment Support';
const groupClientSupport = 'Client Support';
const groupClientCorrespondence = 'Client Correspondence';
const groupOther = 'Other';
const ParaplannerPicklistOptions = [
  { group: groupInAppRequest, name: 'Blueprint data input' },
  { group: groupInAppRequest, name: 'Client summary' },
  { group: groupInvestmentSupport, name: 'Morningstar X-Ray' },
  { group: groupInvestmentSupport, name: '401(k) line-up review' },
  { group: groupInvestmentSupport, name: 'Investment proposal' },
  { group: groupInvestmentSupport, name: 'Investment Ops review' },
  { group: groupClientSupport, name: 'General' },
  { group: groupClientSupport, name: 'Money Flow' },
  { group: groupClientSupport, name: 'Debt Calculator' },
  { group: groupClientSupport, name: 'Files' },
  { group: groupClientCorrespondence, name: 'Request information' },
  { group: groupClientCorrespondence, name: 'Schedule meeting' },
  { group: groupClientCorrespondence, name: 'Reply to client request' },
  { group: groupOther, name: 'Other' },
].map(option => ({ ...option, value: option.name }));

export default ParaplannerPicklistOptions;
